/* eslint-disable eqeqeq */
/* eslint-disable no-plusplus */
/**
 * Functions to control the session storage
 * Attributes saved:
 * apiToken
 */

export const loadState = () => {
  try {
    const serializedState = getCookie('state');
    if (serializedState === null || serializedState === undefined || serializedState === 'undefined') {
      return { apiToken: undefined };
    }
    return JSON.parse(serializedState);
  } catch (error) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    const cookieString = `state=${serializedState};secure;path=/;`;
    document.cookie = cookieString;
  } catch (error) {
    // Ignore write errors.
  }
};
export const setCookie = (name, data) => {
  try {
    const cookieString = `${name}=${data};secure;path=/;`;
    document.cookie = cookieString;
  } catch (error) {
    // Ignore write errors.
  }
};
export const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const cookie = document.cookie.split(';');
  for (let i = 0; i < cookie.length; i++) {
    let item = cookie[i];
    while (item.charAt(0) == ' ') item = item.substring(1, item.length);
    if (item.indexOf(nameEQ) == 0) return item.substring(nameEQ.length, item.length);  
  }
  return null;
};
